import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import styles from './GaugeChart.module.css';

interface GaugeChartProps {
    value?: number;
    unit?: string;
    isHealthIncreasing?: boolean;
    style?: React.CSSProperties;
}

const GaugeChart: React.FC<GaugeChartProps> = ({
    value = 0,
    unit = '',
    isHealthIncreasing = true,
    style
}) => {
    // Three fixed color blocks
    const colorConfig = isHealthIncreasing
        ? [[0.3, '#67e0e3'], [0.7, '#37a2da'], [1, '#fd666d']]
        : [[0.3, '#fd666d'], [0.7, '#37a2da'], [1, '#67e0e3']];

    const option = useMemo(() => {
        return {
            backgroundColor: 'transparent',
            series: [
                {
                    type: 'gauge',
                    radius: '95%',
                    center: ['50%', '55%'],

                    min: 0,
                    max: 100,

                    data: [{ value }],

                    // Keep only the value text
                    detail: {
                        show: true,
                        formatter: `{value} ${unit}`,
                        color: '#ffffff',
                        fontSize: 18,
                        offsetCenter: [0, '35%']
                    },

                    // Three color blocks
                    axisLine: {
                        roundCap: true,
                        lineStyle: {
                            color: colorConfig,
                            width: 18
                        }
                    },

                    // Remove all ticks/labels/split lines
                    axisTick: { show: false },
                    splitLine: { show: false },
                    axisLabel: { show: false },

                    // Keep only the pointer
                    pointer: {
                        show: true,
                        width: 4,
                        length: '60%'
                    },

                    // Hide title above center (if any)
                    title: { show: false },

                    // Optional: remove center anchor dot (if you want cleaner center)
                    anchor: {
                        show: false
                    }
                }
            ]
        };
    }, [value, unit, colorConfig]);

    return (
        <div
            className={styles.chartContainer}
            style={{
                ...style,
                width: '100%',
                height: '100%'
            }}
        >
            <ReactECharts
                option={option}
                style={{ width: '100%', height: '100%' }}
                notMerge={true}
                lazyUpdate={true}
            />
        </div>
    );
};

export default GaugeChart;
